import OntruckMarginCell from './container';

export default OntruckMarginCell;
